import * as type from '../constants/ActionTypes';
import {AFFILIATE_SERVICE_URL} from '../constants/api';
import { CALL_API } from '../login/api.middleware';

export function requestApayout(listReturns, currentAffiliateId) {

  let config = {
    method: 'POST'
  };

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/payouts`,
      config,
      authenticated: true,
      params: {
        listReturns: listReturns,
        affiliateId: currentAffiliateId
      },
      types: [
        type.PAYOUT_REQUEST_REQUEST,
        type.PAYOUT_REQUEST_SUCCESS,
        type.PAYOUT_REQUEST_FAILURE
      ]
    }
  };
}

export function fetchPayouts(affiliateId){

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/payouts`,
      authenticated: true,
      params: {
        affiliateId: affiliateId
      },
      types: [
        type.PAYOUT_REQUEST,
        type.PAYOUT_SUCCESS,
        type.PAYOUT_FAILURE
      ]
    }
  }
}

export function updatePayoutStatus(payoutId, payoutTotal, affiliateId) {

  const body = {
    status: 'paid',
    payoutTotal: payoutTotal,
    affiliateId: affiliateId
  };

  let config = {
    method: 'PUT',
    posAllowed: localStorage.posAllowed,
    body: JSON.stringify(body)
  };

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/payouts/${payoutId}`,
      authenticated: true,
      config,
      types: [
        type.PUT_PAYOUT_STATUS_REQUEST,
        type.PUT_PAYOUT_STATUS_SUCCESS,
        type.PUT_PAYOUT_STATUS_FAILURE
      ]
    }
  }
}

export function fetchPayoutInfo(payoutId){

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/payouts/views/returnInfo`,
      authenticated: true,
      params: {
        payoutId: payoutId,
      },
      types: [
        type.RETURN_INFO_REQUEST,
        type.RETURN_INFO_SUCCESS,
        type.RETURN_INFO_FAILURE
      ]
    }
  };


}